import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import BasicConfiguration from '../BasicConfiguration';
import ScreenSaver from '../ScreenSaver';
import BusinessOutcomeIndicators from '../BusinessOutcomeIndicators';
import LeadIndicators from '../LeadIndicators';
import Results from '../Results';
import {PREFIX_URL} from "../../constants";

class Main extends React.Component {
  render() {
    return (
        <Switch>
            <Route {...this.props} exact path={`${PREFIX_URL}`} component={ScreenSaver} />
            <Route {...this.props} exact path={`${PREFIX_URL}basic-configuration`} component={BasicConfiguration} />
            <Route {...this.props} exact path={`${PREFIX_URL}business-outcome-indicators`} component={BusinessOutcomeIndicators} />
            <Route {...this.props} exact path={`${PREFIX_URL}lead-indicators`} component={LeadIndicators} />
            <Route {...this.props} exact path={`${PREFIX_URL}results`} component={Results} />
        </Switch>
    );
  }
}

export default withRouter(Main);
